import { createMetaRoute } from '@funtech-int/rival';

import { RouteMeta } from '@/shared/lib/navigation';

export const mainRoute = createMetaRoute<RouteMeta>();
